import React from 'react';

const OrdersChart = ({ data = [], loading }) => {
  const hasData = Array.isArray(data) && data.length > 0 && data.some(d => Number(d.daily_orders || d.monthly_orders || 0) > 0);
  const chartItems = hasData ? data : [];

  const maxOrderQty = Math.max(...chartItems.map(d => Number(d.daily_orders || d.monthly_orders || 0)), 1);
  const totalOrdersSum = chartItems.reduce((acc, d) => acc + Number(d.daily_orders || d.monthly_orders || 0), 0);

  return (
    <div className="chart-card-box">
      <div className="card-header-flex">
        <div>
          <h3 className="card-title-text">Orders Overview</h3>
          <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 600 }}>Total Orders: {totalOrdersSum} Placed</span>
        </div>
        <span style={{ fontSize: '11px', fontWeight: 800, color: '#dc2626', background: '#fef2f2', border: '1px solid #fee2e2', padding: '3px 10px', borderRadius: '9999px' }}>Daily Volume</span>
      </div>

      <div className="chart-container-visual" style={{ padding: '16px 0 0' }}>
        {loading ? (
          <div style={{ height: '140px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b', fontSize: '13px' }}>
            Loading order volume...
          </div>
        ) : !hasData ? (
          <div style={{ height: '140px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#64748b', fontSize: '13px' }}>
            <span style={{ fontSize: '13.5px', fontWeight: 700, color: '#0f172a', marginBottom: '4px' }}>No orders placed yet</span>
            <span>Daily order volumes will automatically show here.</span>
          </div>
        ) : (
          <>
            <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-start', gap: '16px', height: '140px', paddingBottom: '4px' }}>
          {chartItems.map((item, i) => {
            const qty = Number(item.daily_orders || item.monthly_orders || 0);
            const heightPercent = Math.max(15, (qty / maxOrderQty) * 100);

            return (
              <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: '1 1 0px', maxWidth: '64px', height: '100%', justifyContent: 'flex-end' }}>
                <span style={{ fontSize: '11px', fontWeight: 800, color: '#0f172a', marginBottom: '4px' }}>
                  {qty}
                </span>
                <div
                  style={{
                    width: '100%',
                    height: `${heightPercent}%`,
                    background: 'linear-gradient(180deg, #ef4444 0%, #dc2626 100%)',
                    borderRadius: '8px 8px 0 0',
                    boxShadow: '0 4px 12px rgba(220, 38, 38, 0.2)',
                    transition: 'height 0.3s ease'
                  }}
                  title={`${item.day_label || item.month_label}: ${qty} orders`}
                />
              </div>
            );
          })}
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '16px', marginTop: '12px', borderTop: '1px solid #f1f5f9', paddingTop: '8px' }}>
          {chartItems.map((item, i) => (
            <span key={i} style={{ flex: '1 1 0px', maxWidth: '64px', textAlign: 'center', fontSize: '11px', fontWeight: 700, color: '#64748b' }}>
              {item.day_label || item.month_label}
            </span>
          ))}
        </div>
        </>
        )}
      </div>
    </div>
  );
};

export default OrdersChart;
